import { useMutation } from '@tanstack/react-query';
import { BasketDetails } from 'shared-types/Basket';
import { Property } from 'shared-types/Property';

export const useApplyPromoCode = (
  property: Property,
  basketDetails: BasketDetails,
  /**
   * @todo Replace Redux action with a direct call
   */
  applyPromoCode: (propertyId: number, basketId: string, newPromoCode: string | null) => void
) => {
  return useMutation({
    mutationFn: async (promoCode: string) =>
      applyPromoCode(property.id, basketDetails.id, (promoCode || '').toUpperCase()),
  });
};
